module.exports = __webpack_public_path__ + "static/img/cantact-top.c5556346.png";